import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import cloneDeep from 'lodash/cloneDeep';
import orderBy from 'lodash/orderBy';
import { LinkContainer } from 'react-router-bootstrap';

import { OverlayTrigger, Tooltip, Button, DropdownButton, MenuItem } from 'react-bootstrap';


import * as Table from 'reactabular-table';
import * as search from 'searchtabular';
import * as sort from 'sortabular';
import * as resolve from 'table-resolver';

import { resetFilter } from 'redux/modules/supervision';

import {
  Paginator, PrimaryControls, paginate
} from '../tableHelpers';

var elevator = require('../../../static/img/elevator.png')
var escalator = require('../../../static/img/escalator.png')

import { generateStateColumn, createStateColumn } from 'utils/analyseState';
import { MobileCardList, MobileCard } from '../common/MobileCard';
import _ from 'underscore'

import moment from 'moment';
var MobileDetect = require('mobile-detect');

import * as FichesActions from 'redux/modules/fiches';
import * as ProductActions from 'redux/modules/products';

import { routeActions } from 'react-router-redux';

import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux';

import { translate } from 'react-i18next';

@translate(['common'])
@connect(
  state => ({
    user: state.auth.user,
    dashboardOptions: state.fiches.dashboardOptions
  }),

  dispatch => bindActionCreators({ ...routeActions, ...ProductActions, resetFilter, ...FichesActions }, dispatch)

)


export default class SyncProductsTableAdmin extends React.Component {
  constructor(props) {
    super(props);

    var rows = this.props.products ? this.props.products : [];

    rows = rows.map((p) => {
      p['state_color'] = createStateColumn(p)
      return p
    })


    this.state = {

      isPhone: false,
      rows,
      searchColumn: 'all',
      query: {}, // search query
      sortingColumns: props.dashboardOptions[props.panel].sortingColumns, // reference to the sorting columns
      columns: this.getColumns(), // initial columns
      pagination: { // initial pagination settings
        page: 1,
        perPage: 7
      }
    };

    this.onRow = this.onRow.bind(this);
    this.onRowSelected = this.onRowSelected.bind(this);
    this.onColumnChange = this.onColumnChange.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onPerPage = this.onPerPage.bind(this);
    this.onToggleColumn = this.onToggleColumn.bind(this);

    this.updateDimensions = this.updateDimensions.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.products !== this.props.products) {
      var rows = this.props.products ? this.props.products : [];

      rows = rows.map((p) => {
        p['state_color'] = createStateColumn(p)
        return p
      })

      this.setState({ rows })
    }
  }

  componentDidMount() {

    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));

  }


  updateDimensions() {
    var md = new MobileDetect(window.navigator.userAgent);

    if (md.tablet() || md.phone()) {
      this.setState({ isPhone: true, columns: this.getColumns() })
    } else {
      this.setState({ isPhone: false, columns: this.getColumns() })
    }
  }



  renderMobileCards(rows) {
    const { t, type, params } = this.props
    const timelineType = { pannes: 'panne', indisponible: 'indisponible', travaux: 'travaux', usager: 'usager' }[type] || 'normal'
    const translateReason = (reason) => reason ? t('sts_infos.' + reason.split(' ').join(''), reason) : ''

    return (
      <MobileCardList empty={t('main.no_sheets')}>
        {rows.map((rowData) => {
          const supPath = '/admin/supervision/' + params.id + '/?id=' + rowData.identification_ID + '&pid=' + rowData.id
          const editProductPath = '/admin/' + params.id + '/product/' + rowData.id + '/edit'
          var cause = null

          if (type == 'cyclical' && rowData.last_cyclical_row) {
            cause = <span><b>{moment(rowData.last_cyclical_row.date_reference).format('DD/MM/YYYY HH:mm')}</b> — {rowData.last_cyclical_row.call_reason}</span>
          } else if (type != 'normal' && type != 'cyclical') {
            var current = _.where(rowData.timeline_rows || [], { type: timelineType, end_code: null })
            cause = current.length > 0
              ? current.map((r, i) => <div key={i}><b>{moment(r.start_date).format('DD/MM/YYYY HH:mm')}</b> — {translateReason(r.call_reason)}</div>)
              : t('main.anomalie')
          }

          return (
            <MobileCard
              key={rowData.id}
              className={type == 'normal' ? '' : (type == 'pannes' || type == 'usager' ? 'mobile-card-red' : 'mobile-card-orange')}
              onClick={() => {
                this.props.expandTabs(1, false)
                this.props.expandBasicTabs(1, true)
                this.props.push(editProductPath)
              }}
              title={rowData.identification_NUM_ASC || t('main.non_renseigne')}
              badge={generateStateColumn(rowData)}
              subtitle={rowData.localisation_adresse}
              fields={[
                cause && { label: t('main.cause'), value: cause },
                rowData.identification_fosse > 0 && { value: <b style={{ color: 'red' }}>{t('main.fond_fosse')}</b> }
              ]}
              actions={[
                <Button key="bilan" bsStyle="warning" bsSize="sm" onClick={() => {
                  this.props.expandTabs(2000, true)
                  this.props.expandBasicTabs(2000, false)
                  this.props.push(editProductPath)
                }}>
                  <i className="fa fa-line-chart" /> {t('main.bilan')}
                </Button>,
                <Button key="sup" bsStyle="primary" bsSize="sm" onClick={() => {
                  this.props.push(supPath)
                  this.props.resetFilter()
                }}>
                  <i className="fa fa-eye" /> {t('main.supervision')}
                </Button>
              ]}
            />
          )
        })}
      </MobileCardList>
    )
  }

  getColumns() {

    var self = this;

    const {t} = this.props

    const sortable = sort.sort({
      getSortingColumns: () => this.state.sortingColumns || [],
      onSort: selectedColumn => {
        this.setState({
          sortingColumns: sort.byColumns({
            sortingColumns: this.state.sortingColumns,
            selectedColumn
          })
        });
        this.props.setDashboardOptions(this.props.panel, true, { sortingColumns: sort.byColumns({ sortingColumns: this.state.sortingColumns, selectedColumn }) })

      }
    });

    const sortableHeader = sortHeader(sortable, () => this.state.sortingColumns);

    var columns = []

    columns = [

      {
        property: 'state_color',
        header: {
          label: t('main.state'),
          formatters: [(v, extra) => sortableHeader(v, extra)],
          props: {
            className: "col-md-1"
          },
        },

        cell: {
          formatters: [
            (value, { rowData }) => {
              return (<span>{generateStateColumn(rowData)}</span>)

            }
          ],

        },
        visible: true,
        filterable: false,
      },

      {

        header: {
          label: t('main.type'),
          props: {
            className: "col-md-1"
          },
          formatters: [sortableHeader]
        },


        cell: {
          formatters: [(value, { rowData }) => {

            if (rowData.identification_type == 'ASC' || rowData.identification_type == 'ASC-IP') {
              var picto = elevator
            } else if (rowData.identification_type == 'EM') {
              var picto = escalator
            } else {
              var picto = false
            }

            if (picto) {
              return (<span><img width="50" src={picto} /></span>)
            } else {
              return <span />
            }
          }]

        },
        width: 20,
        visible: true
      },

      {

        header: {
          label: t('main.state'),
          props: {
            className: "col-md-1"
          }
        },


        cell: {
          formatters: [(value, { rowData }) => {
            return (<span>{generateStateColumn(rowData)}</span>)
          }]

        },
        width: 20,
        visible: false
      }];


    var type;

    if (this.props.type == 'pannes') {
      type = 'panne'
    } else if (this.props.type == 'indisponible') {
      type = 'indisponible'
    } else if (this.props.type == 'travaux') {
      type = 'travaux'

    }
    else if (this.props.type == 'usager') {
      type = 'usager'

    } else {
      type = 'normal'
    }



    if (this.props.type != 'normal' && this.props.type != 'cyclical') {

      columns.push(
        {
          header: {
            label: t('main.cause'),
            formatters: [sortableHeader],
            props: {
              className: "col-md-3"
            }
          },

          cell: {
            formatters: [(value, { rowData }) => {

              if (rowData.timeline_rows.length > 0) {
                var tList = _.where(rowData.timeline_rows, 
                  { 'type': type, 'end_code': null }).map((r) => {

                    try{
                    	var title = t('sts_infos.'+rowData.call_reason.split(' ').join(''))
		    }
	            catch(e){
			var title = "";
		    }
                    
                    return <div>{moment(r.start_date).format('DD/MM/YYYY HH:mm:ss')} : <br /><b>{title}</b></div>


                  })
                  
              } else {
                var tList = t('main.anomalie')
              }

              return (
                <div style={{ maxHeight: '100px', overflowY: 'auto' }}>
                  {tList}
                </div>
              )
            }]
          },
          width: 20,
          visible: true,
          filterable: false,

        }

      );
    }


    if (this.props.type == 'cyclical') {


      columns.push(
        {

          property: 'call_reason',
          header: {
            label: t('main.cause'),

            formatters: [sortableHeader],
            props: {
              className: "col-md-3"
            }
          },
          cell: {
            formatters: [(value, { rowData }) => {

              return rowData.last_cyclical_row ? (
                <div style={{ maxHeight: '100px', overflowY: 'auto' }}>
                  <b>{moment(rowData.last_cyclical_row.date_reference).format('DD/MM/YYYY HH:mm:ss')}</b>
                  <br />
                  {rowData.last_cyclical_row.call_reason}
                  {rowData.identification_fosse > 0 &&
                    <b style={{ "color": "red" }}><br />
                    

                    {t('main.fond_fosse')}
                    
                    
                    </b>

                  }


                </div>
              ) : ''
            }]
          },

          width: 20,
          visible: true
        }
      )

    }



    columns.push(


      {
        property: 'identification_NUM_ASC',
        header: {
          label: t('main.install_num'),
          formatters: [sortableHeader],
          props: {
            className: "col-md-1"
          }
        },
        visible: true
      },


      {
        property: 'localisation_adresse',
        header: {
          label: t('main.address'),
          formatters: [sortableHeader],
          props: {
            className: "col-md-2"
          }
        },
        visible: true
      },

    );




    //if( this.props.user.role != 'user') {
    columns.push(
      {

        header: {
          label: t('main.actions'),

          props: {
            className: "col-md-3"
          }
        },

        cell: {
          formatters: [(value, { rowData }) => {

            var supPath;
            var editProductPath;

            var user = self.props.user;
            var params = self.props.params;

            supPath = '/admin/supervision/' + params.id + '/?id=' + rowData.identification_ID + '&pid=' + rowData.id
            editProductPath = '/admin/' + params.id + '/product/' + rowData.id + '/edit'


            if (this.state.isPhone) {

              var menu =

                (<DropdownButton
                  id={'dashboard-admin-actions-' + this.props.panel + '-' + rowData.id}
                  title={t('main.actions')}
                  key={'12'}
                >
                  <MenuItem eventKey="2">
                    <LinkContainer to={editProductPath}><span>{t('main.edit_sheet')}</span></LinkContainer>
                  </MenuItem>

                  <MenuItem eventKey="3" onClick={() => {
                    self.props.expandTabs(2000, true)
                    self.props.expandBasicTabs(2000, false)
                    self.props.push(editProductPath)
                  }}>
                    {t('main.bilan')}
                  </MenuItem>
                  {/*
                  <MenuItem eventKey="2">
                    <LinkContainer to={editProductPath + '?dispo=1'}><span>Statistiques</span></LinkContainer>
                  </MenuItem>
                  <MenuItem eventKey="3">
                    <LinkContainer to={editProductPath + '?traffic=1'}><span>Disponibilité</span></LinkContainer>
                  </MenuItem>

                  */}

                  <MenuItem eventKey="4">
                    <LinkContainer to={supPath}><span>{t('main.supervision')}</span></LinkContainer>
                  </MenuItem>

                </DropdownButton>)


            } else {

              var supBtn = (
                <button className={"btn btn-sm btn-" + self.props.style} onClick={() => {
                  this.props.push(supPath)
                  this.props.resetFilter()
                }}>
                  <i className="fa fa-eye" />
                </button>)
              /*
              var supBtn =
                <LinkContainer to={supPath}>
                  <button className={"btn btn-sm btn-" + self.props.style} >
                    <i className="fa fa-eye" />
                  </button>
                </LinkContainer>*/

              const tooltip2 = (
                <Tooltip id="tooltip">
                  <strong>{t('main.supervision_entries')}</strong>
                </Tooltip>
              );

              const tooltipEdit = (
                <Tooltip id="tooltip">
                  <strong>{t('main.edit_sheet')}</strong>
                </Tooltip>
              );


              const tooltip3 = (
                <Tooltip id="tooltip">
                  <strong>{t('main.bilan')}</strong>
                </Tooltip>
              );


              const tooltip6 = (
                <Tooltip id="tooltip">
                  <strong>{t('main.disponibility')}</strong>
                </Tooltip>
              );


              var menu =
                (
                  <div>

                    <div style={{ display: 'inline-block', marginLeft: '5px' }}>
                      <OverlayTrigger placement="top" overlay={tooltipEdit}>
                        <button className={"btn btn-sm btn-" + self.props.style} onClick={() => {

                          self.props.expandTabs(1, false)
                          self.props.expandBasicTabs(1, true)
                          self.props.push(editProductPath)
                        }}>
                          <i className="fa fa-pencil" />
                        </button>
                      </OverlayTrigger>
                    </div>

                    &nbsp;
                    <div style={{ display: 'inline-block', marginLeft: '5px' }}>

                      <OverlayTrigger placement="top" overlay={tooltip3}>
                        <Button bsStyle='warning' bsSize="sm" onClick={() => {

                          self.props.expandTabs(2000, true)
                          self.props.expandBasicTabs(2000, false)
                          self.props.push(editProductPath)
                        }}>
                          <i className="fa fa-line-chart" />

                        </Button>
                      </OverlayTrigger>

                    </div>


                    {/*
                    <div style={{ display: 'inline-block', marginLeft: '5px' }}>
                      <OverlayTrigger placement="top" overlay={tooltip3}>
                        <LinkContainer to={editProductPath + '?traffic=1'}>
                          <button className='btn btn-warning btn-sm' disabled={rowData.identification_type == 'EM'}>
                            <i className="fa fa-bar-chart" />
                          </button>
                        </LinkContainer>
                      </OverlayTrigger>
                    </div>

                    <div style={{ display: 'inline-block', marginLeft: '5px' }}>
                      <OverlayTrigger placement="top" overlay={tooltip6}>
                        <LinkContainer to={editProductPath + '?dispo=1'}>
                          <button className='btn btn-warning  btn-sm'>
                            <i className="fa fa-line-chart" />
                          </button>

                        </LinkContainer>
                      </OverlayTrigger>
                    </div>

                    */}

                    <div style={{ display: 'inline-block', marginLeft: '5px' }}>
                      <OverlayTrigger placement="top" overlay={tooltip2}>
                        {supBtn}
                      </OverlayTrigger>
                    </div>

                  </div>
                );

            }
            return menu

          }]


        },
        width: 20,
        visible: true
      }
    )

    return columns;

  }
  render() {

    const {t} = this.props
    const {
      rows,/* pagination, sortingColumns, query, */searchColumn
    } = this.state;

    var columns = this.getColumns()


    let { pagination, sortingColumns, query } = this.props.dashboardOptions[this.props.panel]

    const cols = columns.filter(column => column.visible);

    const paginated = compose(
      paginate(pagination),
      sort.sorter({ columns: cols, sortingColumns, sort: orderBy }),
      search.highlighter({ columns: cols, matches: search.matches, query }),
      search.multipleColumns({ columns: cols, query }),
      resolve.resolve({
        columns: cols,
        method: ({ rowData, column }) => resolve.byFunction('cell.resolve')({
          rowData: resolve.nested({ rowData, column }),
          column
        })
      })
    )(rows);

    return (
      <div>
        {/*<VisibilityToggles
          columns={columns}
          onToggleColumn={this.onToggleColumn}
        />*/}
        <PrimaryControls
          className="controls"
          perPage={pagination.perPage}
          column={searchColumn}
          query={query}
          columns={cols}
          rows={rows}
          onPerPage={this.onPerPage}
          onColumnChange={this.onColumnChange}
          onSearch={this.onSearch}
          t={t}
        />
        {this.renderMobileCards(paginated.rows)}

        <div className="table-responsive resume-panel hidden-xs">
          <Table.Provider
            className="table table-striped"
            columns={cols}
            style={{ overflowX: 'auto' }}
          >
            <Table.Header>
              <search.Columns query={query} columns={cols} onChange={this.onSearch} />
            </Table.Header>

            <Table.Body onRow={this.onRow} rows={paginated.rows} rowKey="id" />

            <CustomFooter columns={cols} rows={paginated.rows} />
          </Table.Provider>

        </div>

        <div className="controls">
          <Paginator
            pagination={pagination}
            pages={paginated.amount}
            onSelect={this.onSelect}
            prevText={t("pagination.previous")}
            nextText={t("pagination.next")}
          />
        </div>
      </div>
    );
  }
  onRow(row, { rowIndex }) {
    return {
      onClick: () => this.onRowSelected(row)
    };
  }
  onRowSelected(row) {

  }
  onColumnChange(searchColumn) {
    this.setState({
      searchColumn
    });
  }
  onSearch(query) {
    this.setState({
      query
    });
    this.props.setDashboardOptions(this.props.panel, true, { query })

  }
  onSelect(page) {
    const pages = Math.ceil(
      this.state.rows.length / this.state.pagination.perPage
    );
    var pagination = {
      ...this.state.pagination,
      page: Math.min(Math.max(page, 1), pages)
    }
    this.setState({
      pagination
    });
    this.props.setDashboardOptions(this.props.panel, true, { pagination })

  }
  onPerPage(value) {
    var pagination = {
      ...this.state.pagination,
      perPage: parseInt(value, 10)
    }
    this.setState({
      pagination
    });

    this.props.setDashboardOptions(this.props.panel, true, { pagination })
  }

  onToggleColumn(columnIndex) {
    const columns = cloneDeep(this.state.columns);
    const column = columns[columnIndex];
    column.visible = !column.visible;
    const query = cloneDeep(this.state.query);
    delete query[column.property];
    this.setState({ columns, query });
  }
}

const CustomFooter = ({ columns, rows }) => {
  return (
    <tfoot>
      <tr>
        {columns.map((column, i) =>
          <td key={`footer-${i}`}>{column.footer ? column.footer(rows) : null}</td>
        )}
      </tr>
    </tfoot>
  );
}

function sortHeader(sortable, getSortingColumns) {
  return (value, { columnIndex }) => {
    const sortingColumns = getSortingColumns() || [];

    return (
      <div style={{ display: 'inline' }}>
        <span className="value">{value}</span>
        {React.createElement(
          'span',
          sortable(
            value,
            {
              columnIndex
            },
            {
              style: { float: 'right' }
            }
          )
        )}
        {sortingColumns[columnIndex] &&
          <span className="sort-order" style={{ marginLeft: '0.5em', float: 'right' }}>
            {sortingColumns[columnIndex].position + 1}
          </span>
        }
      </div>
    );
  };
}
